import { render, staticRenderFns } from "./CommentRank.vue?vue&type=template&id=1fb63984&scoped=true&"
import script from "./CommentRank.vue?vue&type=script&lang=js&"
export * from "./CommentRank.vue?vue&type=script&lang=js&"
import style0 from "./CommentRank.vue?vue&type=style&index=0&id=1fb63984&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb63984",
  null
  
)

export default component.exports